import { Component, OnInit, AfterViewInit, ViewChild, NgZone, ElementRef } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from './config/config.service';
import { ActivatedRoute } from '@angular/router';
import 'leaflet-bing-layer';
import 'esri-leaflet';
import 'esri-leaflet-vector';
import 'leaflet.locatecontrol';
import * as L from 'leaflet';
// import { Map, divIcon, marker, geoJSON, latLng, tileLayer, Browser, Layer, GeoJSON, Icon, LayerGroup, Control, LatLngExpression, LatLng } from 'leaflet';
import * as esri from "esri-leaflet";
import * as Vector from 'esri-leaflet-vector';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, tap, switchMap } from 'rxjs/operators';
import { GeoJsonTypes, Feature, GeoJsonObject } from 'geojson';
import { MatDialog } from '@angular/material/dialog';
import { BuildingDialog } from './building-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import 'leaflet.pattern';
import 'leaflet-arrowheads'
import { AccessibilityService } from './accessibility-service.service';


const BING_KEY = 'AgmwdPOAELwcyd_a30Y6Xq9qD_1YS11OuStJ0YDv1VeDNrG3fECPG7PkIYJtAKEw';
// const SRCH_URL = 'https://dev1.bats.admin.ufl.edu/library/api/searchBldg'; //TEST
const SRCH_URL = 'library/api/searchBldg'; //PROD
const PARAMS = new HttpParams({
  fromObject: {
    origin: '*'
  }
});

var vm;

@Component({
  selector: 'app-root',
  templateUrl: './map.component.html',
  providers: [ConfigService],
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterViewInit {

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private zone: NgZone,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    public a11y: AccessibilityService
  ) { }

  @ViewChild('searchInput', { static: false }) searchInput!: ElementRef<HTMLInputElement>;

  private map: L.Map;
  private sub: any;
  public boundariesLayer: L.GeoJSON;
  public parkingLayer: L.GeoJSON;
  public parkingHaloOuter: L.GeoJSON | null;
  public parkingHaloInner: L.GeoJSON | null;
  layerGroups;
  public searchText: string = '';
  searchFailed;
  id;
  sched;
  showClassSched = false;
  searchedBldg;
  searchedBldgName;

  options = {
    zoom: 15,
    maxZoom: 20,
    center: L.latLng(29.6413659, -82.3516945)
  };

  ngOnInit(): void {
    vm = this;

    this.http.get('assets/sidenav.json')
      .subscribe((data) => {
        this.layerGroups = data;
        this.layerGroups.forEach(element => {
          if (element.TITLE == 'Construction') {
            this.toggleLayer(element.LAYERS[0]);
            this.toggleLayer(element.LAYERS[2]);
            this.toggleLayer(element.LAYERS[3]);
            this.toggleLayer(element.LAYERS[4]);
            this.toggleLayer(element.LAYERS[5]);
            this.toggleLayer(element.LAYERS[6]);
            this.toggleLayer(element.LAYERS[7]);
            this.toggleLayer(element.LAYERS[8]);
            this.toggleLayer(element.LAYERS[9]);
            this.toggleLayer(element.LAYERS[10]);
            this.toggleLayer(element.LAYERS[11]);
          }
          // LEFT AS EXAMPLE - Set dates in advance when certain layers need to be defaulted on
          if (element.TITLE == 'Housing' && (new Date() >= new Date('2026-08-13') && new Date() < new Date('2026-08-17'))) {
            setTimeout(() => {
              this.toggleLayer(element.LAYERS[0]);
            }, 1000);
          }
        });
      });

    this.http.get('assets/boundaries.json')
      .subscribe((data) => this.loadBoundaries(data));

    this.http.get('assets/parking_polys.json')
      .subscribe((data) => this.loadParking(data));

    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];
      this.sched = params['sched'];
    });
  }

  ngAfterViewInit(): void {
    this.map.invalidateSize();
    const input = document.getElementById('typeahead-basic');

    //makes the search drop down scroll when you go up/down it
    input?.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        // wait a tick so ng-bootstrap updates .active
        requestAnimationFrame(() => {
          const active = document.querySelector('.dropdown-item.active') as HTMLElement | null;
          active?.scrollIntoView({ block: 'nearest' });
        });
      }
    });
  }

  onMapReady(map: L.Map) {
    this.map = map;

    //@ts-ignore
    var grey_basemap = Vector.vectorTileLayer(
      "291da5eab3a0412593b66d384379f89f", {
      maxZoom: 20,
      zIndex: -5
    }
    );
    var campus_basemap = Vector.vectorTileLayer(
      "https://tiles.arcgis.com/tiles/IiuFUnlkob76Az9k/arcgis/rest/services/UFColorBasemapStandard/VectorTileServer", {
      maxZoom: 20,
      zIndex: 0
    }
    );

    setTimeout(() => {
      var basemap = new L.LayerGroup([grey_basemap, campus_basemap]);

      map.setMinZoom(4);
      map.setMaxZoom(20);

      var aerial = esri.basemapLayer('Imagery', {
        maxZoom: 20,
        detectRetina: true,
        zIndex: -5
      });

      map.options.zoomSnap = 0.5;
      map.options.zoomDelta = 0.5;

      var baseMaps = {
        "Street": basemap,
        "Aerial": aerial
      };

      var layerControl = new L.Control.Layers(baseMaps, null, { collapsed: false });
      layerControl.addTo(this.map);
      basemap.addTo(this.map);

      const base = layerControl.getContainer()?.querySelector('.leaflet-control-layers-base') as HTMLElement | null;
      if (base) {
        base.setAttribute('role', 'radiogroup'); // tell AT it's one choice group
        base.setAttribute('aria-label', 'Map style'); // the group name users will hear
      }


      //add ID to map controls to allow for "skip to map controls" button...
      const zoomIn = map.getContainer().querySelector('.leaflet-control-zoom-in') as HTMLElement;
      if (zoomIn) { zoomIn.id = 'map-zoom-in'; } // give it an id we can target

    }, 1000);


    var locator = new L.Control.Locate();
    locator.addTo(this.map);

    //add this for locate button proper aria state for screen readers
    const locateBtn = document.querySelector('.leaflet-control-locate a') as HTMLElement;
    if (locateBtn) {
      locateBtn.setAttribute('role', 'button');
      locateBtn.setAttribute('aria-pressed', 'false');
    }

    // whenever you check state (e.g. on map moveend, or with MutationObserver)
    const on = document.querySelector('.leaflet-control-locate')?.classList.contains('active');
    locateBtn?.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  style(feature) {
    return {
      fillColor: '#2196F3',
      weight: 0,
      opacity: 1,
      color: '#2196F3',
      dashArray: '3',
      fillOpacity: 0.0
    };
  }

  routeStyle(feature: Feature) {
    var color;
    var dashArray;
    if (!feature.properties.SERVICELEVEL) {
      if (feature.properties.trailsurface) {
        switch (feature.properties.trailsurface) {
          case 'Wood':
            color = '#e0b6a8';
            dashArray = "10,5";
            break;
          case 'Asphalt':
            color = '#87888d';
            dashArray = "2,12";
            break;
          case 'Concrete':
            color = '#C7C9C8';
            dashArray = "6,6";
            break;
          case 'Dirt':
            color = '#cfb199';
            dashArray = "1,12";
            break;
          case 'Mulch':
            color = '#aa7e6d';
            dashArray = "8,10,1,10";
            break;
          default: // Mixed Material
            color = '#df6540';
            dashArray = null; // solid
            break;
        }
        
      } else {
        if (feature.properties.FULLNAME) {
          switch (feature.properties.FULLNAME){
            case 'The Boot':
              color = '#eede00';
              dashArray = '1,5';
              break;
            case 'SW Rec':
              color = '#00ff6a';
              dashArray = '5,5';
              break;
            case 'Stadium':
              color = '#7b71ff';
              dashArray = '10,5';
              break;
            case 'Fraternity Row':
              color = '#ff9d9d';
              dashArray = '10,10';
              break;
            default: 
              color = '#22884c';
              dashArray = '15,10';
              break;
          }
          
        }
        else {
          return {
            "color": '#000000',
            "weight": 4,
            "opacity": 0.9,
            "dashArray": "5,10",
            "className": 'routeLine',
          };
        }
      }

      
      
    }
    else {
      switch (feature.properties.SERVICELEVEL) {
        case 1:
          color = '#2196F3';
          dashArray = null; //solid line
          break;
        case 2:
          color = '#FFC107';
          dashArray = '8,6'; //long dash
          break;
        default:
          color = '#f44336';
          dashArray = '2,6' //short dash
          break;
      }
    }
    
    return {
      "color": color,
      "weight": 3,
      "opacity": 0.9,
      "dashArray": dashArray,
      "className": 'routeLine'
    };
  }

  detourStyle(feature: any) {
    var color = "#1565C0";//F4511E
    var dashArray = "1";
    switch (feature.properties.close_type) {
      case 'Pedestrian':
        color = '#304FFE';
        dashArray = "2,8";
        break;
      default:
        color = '#F4511E'; //ORANGE - CLOSURE LINES
        break;
    }
    return {
      "color": color,
      "dashArray": dashArray,
      "weight": 4,
      "opacity": 1,
      "className": 'routeLine'
    };
  }

  flowStyle(feature: any) {
    var color = "#1565C0";
    var dashArray = "1";
    return {
      "color": color,
      "dashArray": dashArray,
      "weight": 4,
      "opacity": 1,
    };
  }

  hoveredStyle(feature) {
    return {
      weight: 5,
      color: '#0D47A1',
      dashArray: '',
      fillOpacity: 0.2
    };
  }

  leedStyle(feature: Feature) {
    switch (feature.properties.SUSTAIN_STATUS) {
      case "LEED Certified":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -45, color: '#76FF03', spaceColor: '#000', spaceOpacity: 1, weight: 6, spaceWidth: 6 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#22884C',
          "color": '#22884C',
          "weight": 0,
          "opacity": 0.9,
          "fillOpacity": 0.5,
          "fillPattern": nonPattern
        };
      case "LEED Silver":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -180, color: '#FAFAFA', spaceColor: '#000', spaceOpacity: 1, weight: 6, spaceWidth: 6 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#E0E0E0',
          "color": '#FAFAFA',
          "weight": 0,
          "opacity": 0.9,
          "fillOpacity": 0.5,
          "fillPattern": nonPattern
        };
      case "LEED Gold":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -135, color: '#FFC107', spaceColor: '#000', spaceOpacity: 1, weight: 6, spaceWidth: 6 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#FFC107',
          "color": '#FFC400',
          "weight": 0,
          "opacity": 0.9,
          "fillOpacity": 0.5,
          "fillPattern": nonPattern
        };
      case "LEED Platinum":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -90, color: '#3F51B5', spaceColor: '#fff', spaceOpacity: 1, weight: 6, spaceWidth: 6 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#3F51B5',
          "color": '#3D5AFE',
          "weight": 0,
          "opacity": 0.9,
          "fillOpacity": 0.5,
          "fillPattern": nonPattern
        };
      default:
        return {
          "fillColor": '#4CAF50',
          "color": '#4CAF50',
          "weight": 1,
          "opacity": 0.0,
          "fillOpacity": 0.0
        };
    }
  }

  defaultPolyStyle() {
    return {
      color: '#0021A5',
      weight: 1,
      opacity: 0.5,
    }
  }

  moveinStyle(feature: Feature) {
    switch (feature.properties.zone_type) {
      case "High Traffic Zone":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -45, color: '#FB8C00', spaceOpacity: 0.5 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#149ece',
          "color": '#149ece',
          "weight": 5,
          "opacity": 0.9,
          "fillOpacity": 0.4,
          "fillPattern": nonPattern
        };
      case "Limited Availability":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -45, color: '#FDD835', spaceOpacity: 0.5 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#FDD835',
          "color": '#F9A825',
          "weight": 5,
          "opacity": 0.9,
          "fillOpacity": 0.4,
          "fillPattern": nonPattern
        };
      case "Parking for Move In":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -45, color: '#8E24AA', spaceOpacity: 0.5 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#9e559c',
          "color": '#9e559c',
          "weight": 5,
          "opacity": 0.9,
          "fillOpacity": 0.4,
          "fillPattern": nonPattern
        };
      case "Queuing Location":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -45, color: '#EC407A', spaceOpacity: 0.5 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#EC407A',
          "color": '#D81B60',
          "weight": 5,
          "opacity": 0.9,
          "fillOpacity": 0.4,
          "fillPattern": nonPattern
        };
      case "Unloading Zone":
        //@ts-ignore
        var nonPattern = new L.StripePattern({ angle: -45, color: '#3949AB', spaceOpacity: 0.5 });
        nonPattern.addTo(vm.map);
        return {
          "fillColor": '#ed5151',
          "color": '#ed5151',
          "weight": 5,
          "opacity": 0.9,
          "fillOpacity": 0.4,
          "fillPattern": nonPattern
        };
      default:
        return {
          "fillColor": '#4CAF50',
          "color": '#4CAF50',
          "weight": 5,
          "opacity": 0.0,
          "fillOpacity": 0.0
        };
    }
  }

  loadBoundaries(data): void {
    this.boundariesLayer = L.geoJSON(data, {
      style: this.style,
      onEachFeature: function onEachFeature(feature, layer) {
        layer.on({
          mouseover: function highlightFeature(e) {
            var layer = e.target;
            layer.setStyle(vm.hoveredStyle());
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
              layer.bringToFront();
            }
          },
          mouseout: function resetHighlight(e) {
            var layer = e.target;
            layer.setStyle(vm.style());
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
              layer.bringToFront();
            }
          },
          click: function zoomToFeature(e) {
            var layer = e.target;
            vm.zone.run(() => { vm.openBuildingDialog(layer); });
          }
        });
      }
    })
    this.boundariesLayer.addTo(this.map);
    if (this.id != null) {
      var obj = { "item": { "BLDG": this.id } };
      this.handleSearchResults(obj);
    }

    if (this.sched != null) {
      this.showSchedule();
    }
  }

  loadParking(data): void {
    // index/total (for ARIA)
    if (data?.features?.length) {
      const total = data.features.length;
      data.features.forEach((f: any, i: number) => {
        f.properties._layerIndex = i + 1;
        f.properties._layerTotal = total;
      });
    }

    this.parkingHaloOuter = L.geoJSON(data, {
      style: () => ({ color: 'white', weight: 3, opacity: 1, fillOpacity: 0, lineJoin: 'round', lineCap: 'round' }),
      interactive: false
    });

    this.parkingHaloInner = L.geoJSON(data, {
      style: () => ({ color: 'black', weight: 2, opacity: 1, fillOpacity: 0, lineJoin: 'round', lineCap: 'round' }),
      interactive: false
    });

    this.parkingHaloOuter.on('add', () =>
      this.parkingHaloOuter!.eachLayer((l: any) => l._path?.setAttribute('aria-hidden', 'true'))
    );
    this.parkingHaloInner.on('add', () =>
      this.parkingHaloInner!.eachLayer((l: any) => l._path?.setAttribute('aria-hidden', 'true'))
    );
    // interactive GeoJSON layer
    this.parkingLayer = L.geoJSON(data, {
      style: this.style as any,
      onEachFeature: function onEachFeature(feature, layer) {
        layer.on({
          mouseover: function highlightFeature(e) {
            var l = e.target;
            l.setStyle(vm.hoveredStyle());
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
              l.bringToFront();
            }
          },
          mouseout: function resetHighlight(e) {
            var l = e.target;
            l.setStyle(vm.style());
            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
              l.bringToFront();
            }
          }
        });

        // keep your popup and aria stuff below here, unchanged...
        const html = feature?.properties?.CUSTOM_POPUP;
        if (html) {
          layer.bindPopup(html);
          (layer as any).once('add', () => {
            const el = (layer as any)._path as SVGPathElement | undefined;
            if (!el) return;
            el.setAttribute('tabindex', '0');
            el.setAttribute('role', 'button');
            el.addEventListener('focus', () => el.classList.add('poly-focus'));
            el.addEventListener('blur', () => el.classList.remove('poly-focus'));
          });
        } else {
          (layer as any).off();
          (layer as any).options.interactive = false;
          (layer as any).once('add', () => {
            const el = (layer as any)._path as SVGPathElement | undefined;
            if (!el) return;
            el.style.pointerEvents = 'none';
            el.style.cursor = 'default';
          });
        }

        (layer as any).once('add', () => {
          const el = (layer as any)._path as SVGPathElement | undefined;
          if (!el) return;
          const info = vm.createInfo({ NAME: 'Parking' }, feature);
          const idx = feature?.properties?._layerIndex;
          const tot = feature?.properties?._layerTotal;
          const parts: string[] = [];
          if (info?.title) parts.push(`${info.title}${idx && tot ? ` ${idx} of ${tot}` : ''}.`);
          if (info?.lines?.length) parts.push(info.lines.join('. ') + '.');
          el.setAttribute('role', 'img');
          el.setAttribute('aria-label', parts.join(' '));
        });
      }
    });

    // add to the map
    this.parkingLayer.addTo(this.map);
  }



  handleSearchResults(result: any) {
    var lowestLayer: L.GeoJSON<Feature>;
    var lowestId = 999999;
    var layers = this.boundariesLayer.eachLayer(
      layer => {
        var anLayer = <L.GeoJSON>layer;
        var feature = <Feature>anLayer.feature;
        if (feature.properties.PropHID == result.item.BLDG || feature.properties.PropCID == result.item.BLDG) {
          if (!lowestLayer || Number(feature.id) < lowestId) {
            lowestId = <number>feature.id;
            lowestLayer = anLayer;
          }
        }

      }
    );
    if (lowestLayer) {
      this.zoomToLayer(lowestLayer);
      this.map.once('moveend', () => this.openBuildingDialog(lowestLayer!)); //open modal after zoom finishes
    } else {
      this.searchedBldg = result.item.BLDG;
      this.searchedBldgName = result.item.NAME;
      this.zoomToLatLon(result.item.LAT, result.item.LON, result.item.BLDG);
      this.map.once('moveend', () => this.openBuildingDialog(lowestLayer!)); //open modal after zoom finishes
    }
  }

  toggleLayer(layer) {
    layer.CHECKED = !layer.CHECKED;
    if (layer.CHECKED) {
      if (layer.MAP_LAYER) {
        layer.MAP_LAYER.addTo(this.map);
      } else {
        if (layer.TYPE == 'VECTOR') {
          layer.MAP_LAYER = Vector.vectorTileLayer(
            layer.FILENAME, {
            maxZoom: 20,
            zIndex: 9999
          }
          );
          layer.MAP_LAYER.addTo(this.map);
        } else {
          this.http.get('assets/' + layer.FILENAME)
            .subscribe((data) => this.setLayer(data, layer));
        }

      }
      if (layer.NAME == 'Permitted Parking') {
        this.parkingHaloOuter.addTo(this.map);
        this.parkingHaloInner.addTo(this.map);
      }
    } else {
      layer.MAP_LAYER.removeFrom(this.map);
      if (layer.NAME == 'Permitted Parking') {
        this.parkingHaloOuter.removeFrom(this.map);
        this.parkingHaloInner.removeFrom(this.map);
      }
    }
  }

  clean(v: any): string {
    let s = String(v ?? '').trim();
    if (!s) return '';

    const bad = ['na', 'n/a', 'unknown', 'unidentified'];
    if (bad.includes(s.toLowerCase())) return '';

    // Normalize whitespace (newlines, tabs, multiple spaces → single space)
    s = s.replace(/\s+/g, ' ');

    // normalize backticks to apostrophes for screen reader clarity
    s = s.replace(/`/g, "'");

    return s;
  }


  createInfo(layer: any, feature: any) {
    const properties = feature.properties;
    let title = layer.NAME;
    const lines: string[] = [];
    let popupOnly = null;

    if (layer.NAME === 'Accessible Entrances') {
      title = `Accessible Entrance`;
      let bldg = this.clean(properties.BLDGNO);
      let room = this.clean(properties.ROOM_NUM);

      if (bldg) lines.push(`Building Number ${bldg}`);
      if (room) lines.push(`Room ${room}`);
    }
    if (layer.NAME == 'ADA Parking') {
      title = `ADA Parking`;
    }
    if (layer.NAME == 'Bus Stops') {
      title = `Bus Stop`;
      let name = properties.stop_name;
      let rating = properties.RATING;

      if (name) lines.push(`${name}`);
      if (rating) lines.push(`${rating}`);
    }
    if (layer.NAME == 'SNAP Locations') {
      title = `SNAP Location`;
      lines.push(properties.NAME);
    }
    if (layer.NAME == 'AEDs') {
      let _popupOnly = [];
      if(properties.aeds) {
        title = `Building AEDs`;
        properties.aeds.forEach(aed => {
          let _aed = [];
          _aed.push(`<em>${aed.MODEL}</em>`);
          if(aed.SERIALID) {
            _aed.push(`Serial: ${aed.SERIALID}`)
          }
          if(aed.LOCATION) {
            _aed.push(aed.LOCATION)
          }
          if(aed.LOCATION_DESCR) {
            _aed.push(`<em>${aed.LOCATION_DESCR}</em>`)
          }
          _popupOnly.push(_aed.join('<br>'));
        });
        popupOnly = `
        <ul>
          <li>
            ${_popupOnly.join('</li><li>')}
          </li>
        </ul>
        `;
      }
      else {
        title = `AED`;
        _popupOnly.push(properties.MODEL);
        if(properties.SERIALID) {
          _popupOnly.push(`Serial: ${properties.SERIALID}`)
        }
        if(properties.LOCATION) {
          _popupOnly.push(properties.LOCATION)
        }
        if(properties.LOCATION_DESCR) {
          _popupOnly.push(`<em>${properties.LOCATION_DESCR}</em>`)
        }
        if(properties.IMG_GUID) {
          _popupOnly.push(`<img src="/library/api/attachment-public/attachment?guid=${properties.IMG_GUID}" >`)
        }    
        popupOnly = _popupOnly.join('<br>');
      }
    }
    if (layer.NAME == 'Blue Phones') {
      title = `Blue Phone`;
      let name = this.clean(properties.NAME);
      if (name) lines.push(`${name}`);
    }
    if (layer.NAME == 'Outdoor Speakers') {
      title = `Outdoor Speaker`;
    }
    if (layer.NAME == 'ATMs') {
      title = `ATM`;
      let name = properties.Name;
      let provider = properties.Provider;

      if (provider) lines.push(`${provider}`);
      if (name) lines.push(`${name}`);
    }
    if (layer.NAME == 'Dining') {
      title = `Dining`;
      let name = properties.NAME;
      let locations = properties.Locations;

      if (name) lines.push(`${name}`);
      if (locations) lines.push(`Restaurants: ${locations}`);
    }
    if (layer.NAME == 'Registered Locations') {
      title = 'Registered Location';
      let name = properties.name;
      if (name) lines.push(`${name}`);
    }
    if (layer.NAME == 'Administration') {
      let name = properties.NAME;
      let building = properties.BLDG;
      if (name) lines.push(`${name}`);
      if (building) lines.push(`Building Number ${building}`);
      popupOnly = properties.URL;
    }
    if (layer.NAME == 'Libraries') {
      title = 'Library';
      let name = properties.name;
      if (name) lines.push(`${name}`);
    }
    if (
      layer.NAME == 'UF Bookstore & Welcome Center' ||
      layer.NAME == 'Reitz Student Union' ||
      layer.NAME == 'The Hub' ||
      layer.NAME == 'TAPS Transportation and Parking Services' ||
      layer.NAME == 'Collegiate Veterans Success Center' ||
      layer.NAME == 'Dean of Students Office' ||
      layer.NAME == 'Disability Resource Center' ||
      layer.NAME == 'Counseling and Wellness Center' ||
      layer.NAME == 'Housing Administration' ||
      layer.NAME == 'University Police Department' ||
      layer.NAME == 'Student Health Care Center' ||
      layer.NAME == 'Office of the Registrar' ||
      layer.NAME == 'Field and Fork Food Pantry') {
      title = null;
    }
    if (layer.NAME == 'Walk-up Computers') {
      lines.push(`${properties.NAME}`);
      lines.push(`${properties.DESCRIPTION}`);
    }
    if (layer.NAME == 'Walk-up Printers') {
      lines.push(`${properties.NAME}`);
      lines.push(`${properties.DESCRIPTIO}`);
    }
    if (layer.NAME == 'Scooter/Motorcycle') {
      title = 'Scooter/Motorcycle Parking';
    }
    if (layer.NAME == 'Fix-It Stations') {
      title = 'Fix-It Station';
    }
    if (layer.NAME == 'Inclusive, Family Restrooms') {
      title = 'Inclusive, Family Restroom';
      lines.push(`Building Number ${properties.bldg}`);
      lines.push(`Floor ${properties.fl}`);
      lines.push(`Room ${properties.room}`);
    }
    if (layer.NAME == 'Inclusive, Unisex Restrooms') {
      title = 'Inclusive, Unisex Restroom';
      lines.push(`Building Number ${properties.bldg}`);
      lines.push(`Floor ${properties.fl}`);
      lines.push(`Room ${properties.room}`);
    }
    if (layer.NAME == 'Health and Wellness Services') {
      title = 'Health and Wellness Service';
      lines.push(`${properties.NAME}`);
    }
    if (layer.NAME == 'Lactation Rooms') {
      title = 'Lactation Room';
      lines.push(`${properties.bldg_name_1}`);
      lines.push(`Floor ${properties.floor}`);
      lines.push(`Room ${properties.room}`);
    }
    if (layer.NAME == 'Recreation and Fitness') {
      lines.push(`${properties.NAME}`);
    }
    if (layer.NAME == 'ADA Routes') {
      title = 'ADA Route';
      let status;
      if (properties.SERVICELEVEL == 1) status = 'Accessible';
      if (properties.SERVICELEVEL == 2) status = 'Use Caution';
      if (properties.SERVICELEVEL == 3) status = 'Not Accessible';

      lines.push(`${status}`);
    }
    if (layer.NAME == 'Trails') {
      title = 'Trail';
      lines.push(`${properties.location}`);
      lines.push(`Trail Surface: ${properties.trailsurface}`);
    }
    if (layer.NAME == 'Closure Areas') {
      title = 'Closer Area';
      lines.push(`${properties.IMPACT_NAME}`);
      lines.push(`${properties.START_DATE} through ${properties.END_DATE} `);
    }
    if (layer.NAME == 'Green Buildings') {
      const hasLeedStatus = (f: any) =>
        ['LEED Certified', 'LEED Silver', 'LEED Gold', 'LEED Platinum']
          .includes(f?.properties?.SUSTAIN_STATUS);
      if (hasLeedStatus) {
        title = 'Green Building';
        if (this.clean(properties.PropName)) {
          lines.push(`${this.clean(properties.PropName)}`);
        }
        lines.push(`${properties.SUSTAIN_STATUS}`);
      }
    }
    if (layer.NAME == 'Parking') {
      if (this.clean(properties.FAC_NAME)) {
        lines.push(`${this.clean(properties.FAC_NAME)}`);
      }
      let zone_des = this.clean(properties.ZONE_DES);
      if (zone_des) {
        if (zone_des == 'Any Permit' || zone_des == 'Visitor' || zone_des == 'Reserved') {
          lines.push(`${this.clean(properties.ZONE_DES)} Parking`);
        } else if (zone_des == 'Service') {
          lines.push(`${this.clean(properties.ZONE_DES)}`);
        }
        else lines.push(`${this.clean(properties.ZONE_DES)} Permit Parking`);
      }
    }
    if(layer.NAME == 'Pedestrian Detour' || layer.NAME == 'One Way Detour' || layer.NAME == 'Two Way Detour' || 
      layer.NAME == 'One Way Traffic' || layer.NAME == 'Two Way Traffic' || 
      layer.NAME == 'Emergency Only' || layer.NAME == 'Flagman' || layer.NAME == 'Two Way Detour' || layer.NAME == 'Information'){
      if (this.clean(properties.IMPACT_NAME)) {
          lines.push(`${this.clean(properties.IMPACT_NAME)}`);
        }
        lines.push(`Start Date: ${properties.START_DATE}`);
        lines.push(`End Date: ${properties.END_DATE}`);
    }
    if(layer.NAME == 'Hiking Trails'){
      if(this.clean(properties.trailsurface)) lines.push(`${this.clean(properties.trailsurface)} Surface`);
      if(this.clean(properties.location)) lines.push(`${this.clean(properties.location)}`)
    }
    return { title, lines, popupOnly };
  }

  setLayer(data, layer) {
    switch (layer.TYPE) {
      case 'POLY':
        this.setPolyLayer(data, layer);
        break;
      case 'LINE':
        this.setLineLayer(data, layer);
        break;
      default:
        this.setPointLayer(data, layer);
        break;
    }
  }

  setPointLayer(data, layer) {
    const anIcon = L.divIcon({
      html: `
      <span class="text-center fa-stack position-absolute" style="top:50%;left:50%; transform:translate(-50%, -50%);" aria-hidden='true'>
        <i class="fas fa-circle fa-stack-2x" style="color: #${layer.PRIMARY_HEX};" ></i>
        <i class="fas fa-stack-1x ${layer.ICON}" style="color: ${this.a11y.getAccessibleColor('#' + layer.PRIMARY_HEX)};"></i>
      </span>`,
      className: 'mapIcon'
    });

    //give each pin a unique ID number for accessibility...
    if (data && data.features) {
      const total = data.features.length;
      data.features.forEach((f: any, i: number) => {
        f.properties._layerIndex = i + 1;   // 1-based
        f.properties._layerTotal = total;
      });
    }

    layer.MAP_LAYER = L.geoJSON(data, {
      pointToLayer: (feature, latlng) => {

        let info = this.createInfo(layer, feature); //generate formatted info about pin for aria readers
        let mark = L.marker(latlng, { icon: feature.properties.CUSTOM_ICON ? new L.Icon({ iconUrl: 'assets/' + feature.properties.CUSTOM_ICON, iconSize: [30, 30] }) : anIcon });
        if (feature.properties.CUSTOM_POPUP) {
          if (feature.properties.CUSTOM_POPUP) {
            const custom = feature.properties.CUSTOM_POPUP;
            let html = custom;
            if (info.title) html = `<b>${info.title}</b><br>${custom}`;
            mark.bindPopup(html);
          }
        } else {
          // popup for sighted users
          let html = `<b>${info.title}</b>`;
          if (info.lines.length) html += '<br>' + info.lines.join('<br>');
          if (info.popupOnly) html += '<br>' + info.popupOnly;
          mark.bindPopup(html);
        }
        // aria-label for SR users
        mark.once('add', () => {
          const el = mark.getElement();
          if (!el) return;
          const idx = feature.properties._layerIndex;
          const total = feature.properties._layerTotal;
          let aria;
          if (info.title == null) {
            aria = layer.NAME;
          } else {
            aria = `${info.title} ${idx} of ${total}. ${info.lines.join('. ')}`;
          }
          el.setAttribute('aria-label', aria);
          el.setAttribute('role', 'button');


        });
        return mark;
      }
    })

    layer.MAP_LAYER.addTo(this.map);

    // update layer tabbability based on if it is in view or not
    const updatePointTab = () => {
      const mapB = this.map.getBounds();
      layer.MAP_LAYER.eachLayer((m: any) => {
        if (typeof m.getLatLng !== 'function') return; // only markers
        const el = m.getElement?.();
        if (!el) return;

        const inView = mapB.contains(m.getLatLng());
        if (inView) {
          el.setAttribute('tabindex', '0');
          el.removeAttribute('aria-hidden');
        } else {
          el.removeAttribute('tabindex');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    };

    updatePointTab();
    this.map.on('moveend zoomend', updatePointTab);
  }

  setPolyLayer(data, layer) {
    const hasLeedStatus = (f: any) =>
      ['LEED Certified', 'LEED Silver', 'LEED Gold', 'LEED Platinum']
        .includes(f?.properties?.SUSTAIN_STATUS);

    //index/total (for ARIA)
    if (data?.features?.length) {
      const total = data.features.length;
      data.features.forEach((f: any, i: number) => {
        f.properties._layerIndex = i + 1;
        f.properties._layerTotal = total;
      });
    }

    const isLeedLayer = layer.NAME === 'Green Buildings'; //don't show outline for normal buildings if we are showing the green buildings

    // black and white outlines for 3:1 contrast
    const polyOuterWhite = L.geoJSON(data, {
      style: () => ({ color: 'white', weight: 4, opacity: 1, fillOpacity: 0, lineJoin: 'round', lineCap: 'round' }),
      interactive: false,
      filter: isLeedLayer ? hasLeedStatus : undefined
    });

    const polyInnerBlack = L.geoJSON(data, {
      style: () => ({ color: 'black', weight: 2, opacity: 1, fillOpacity: 0, lineJoin: 'round', lineCap: 'round' }),
      interactive: false,
      filter: isLeedLayer ? hasLeedStatus : undefined
    });

    polyOuterWhite.on('add', () => polyOuterWhite.eachLayer((l: any) => l._path?.setAttribute('aria-hidden', 'true')));
    polyInnerBlack.on('add', () => polyInnerBlack.eachLayer((l: any) => l._path?.setAttribute('aria-hidden', 'true')));

    // allow different layers to have different style options
    let styleFn: L.PathOptions | ((f: any) => L.PathOptions) = this.defaultPolyStyle();
    let onEachFeatureFn: (feature: any, poly: L.Path) => void;

    if (layer.NAME === 'Green Buildings') {
      styleFn = this.leedStyle;
      onEachFeatureFn = (_feature: any, _poly: L.Path) => { };
    } else if (layer.NAME === 'Fall 2026 Move-In') {
      styleFn = this.moveinStyle;
      onEachFeatureFn = (feature: any, poly: L.Path) => {
        poly.bindPopup(feature.properties.CUSTOM_POPUP);
      };
    } else {
      // default branch uses provided style + optional pattern
      const anStyle = { ...(layer.STYLE || this.defaultPolyStyle()) };
      if (layer.PATTERN_COLOR) {
        // @ts-ignore StripePattern available in your env
        const nonPattern = new L.StripePattern({ angle: -45, color: layer.PATTERN_COLOR, spaceOpacity: 0.5 });
        nonPattern.addTo(this.map);
        (anStyle as any).fillPattern = nonPattern;
      }
      styleFn = anStyle;
      onEachFeatureFn = (feature: any, poly: L.Path) => {
        poly.bindPopup(feature.properties.CUSTOM_POPUP);
      };
    }

    // make polygons
    const interactivePolys = L.geoJSON(data, {
      style: styleFn as any,
      onEachFeature: (feature: any, poly: L.Path) => {
        const html = feature?.properties?.CUSTOM_POPUP;

        if (html) { //if there is a popup, bind it
          poly.bindPopup(html);
          (poly as any).once('add', () => {
            const el = (poly as any)._path as SVGPathElement | undefined;
            if (!el) return;
            el.setAttribute('tabindex', '0');
            el.setAttribute('role', 'button');
            el.addEventListener('focus', () => el.classList.add('poly-focus'));
            el.addEventListener('blur', () => el.classList.remove('poly-focus'));

          });
        } else {
          //if no popup, make it not-interactable
          (poly as any).off();
          (poly as any).options.interactive = false;
          (poly as any).once('add', () => {
            const el = (poly as any)._path as SVGPathElement | undefined;
            if (!el) return;
            el.style.pointerEvents = 'none';
            el.style.cursor = 'default';
          });
        }

        // add aria label
        (poly as any).once('add', () => {
          const el = (poly as any)._path as SVGPathElement | undefined;
          if (!el) return;

          const info = this.createInfo(layer, feature);
          const idx = feature.properties._layerIndex;
          const tot = feature.properties._layerTotal;

          const parts: string[] = [];
          if (info?.title) parts.push(`${info.title}${idx && tot ? ` ${idx} of ${tot}` : ''}.`);
          if (info?.lines?.length) parts.push(info.lines.join('. ') + '.');

          el.setAttribute('role', 'img'); //treat as images for screen readers
          el.setAttribute('aria-label', parts.join(' '));
        });
      }
    });

    layer.MAP_LAYER = L.layerGroup([polyOuterWhite, polyInnerBlack, interactivePolys]);
    layer.MAP_LAYER.addTo(this.map);
  }


  setLineLayer(data, layer) {
    let layerInfo = layer;

    const routeCanvas = L.canvas({ padding: 0.2 }) as any;

    // outer white halo
    const outerWhite = L.geoJSON(data, {
      renderer: routeCanvas,
      interactive: false,
      filter: (f: any) => {
        const color = this.routeStyle(f).color?.toLowerCase();
        return color !== '#ffffff' && color !== '#fff'; // skip if route is white
      },
      style: () => ({
        color: 'white',
        weight: 5,
        opacity: 1,
        lineJoin: 'round',
        lineCap: 'round'
      })
    } as any);

    // inner black halo
    const innerBlack = L.geoJSON(data, {
      renderer: routeCanvas,
      interactive: false,
      filter: (f: any) => {
        const color = this.routeStyle(f).color?.toLowerCase();
        return color !== '#000000' && color !== '#000'; // skip if route is black
      },
      style: () => ({
        color: 'black',
        weight: 4,
        opacity: 1,
        lineJoin: 'round',
        lineCap: 'round'
      })
    } as any);

    if (data && data.features) {
      const total = data.features.length;
      data.features.forEach((f: any, i: number) => {
        f.properties._layerIndex = i + 1;
        f.properties._layerTotal = total;
      });
    }

    //normal SVG routes on top
    const svgRoutes = L.geoJSON(data, {
      style: this.routeStyle.bind(this),
      onEachFeature: (feature: any, layer: L.Path) => {
        const info = this.createInfo(layerInfo, feature);

        //aria label
        (layer as any).on('add', () => {
          const el = (layer as any)._path as SVGPathElement | undefined;
          if (!el) return;

          let index = feature.properties._layerIndex;
          let total = feature.properties._layerTotal;

          let ariaParts = [];

          if (info.title) ariaParts.push(`${info.title} ${index} of ${total}.`);
          if (info.lines?.length) ariaParts.push(info.lines.join('. ') + '.');

          el.setAttribute('role', 'img'); //treat the routes as images
          el.setAttribute('aria-label', ariaParts.join(' '));

        })
      }
    });

    layer.MAP_LAYER = L.layerGroup([outerWhite, innerBlack, svgRoutes]);
    layer.MAP_LAYER.addTo(this.map);
  }

  setTwoWayDetourLayer(data, layer) {
    layer.MAP_LAYER = L.geoJSON(data, {
      style: this.detourStyle,
      //@ts-ignore
      arrowheads: { frequency: 'startend' }
    });

    layer.MAP_LAYER.addTo(this.map);
  }

  setOneWayDetourLayer(data, layer) {
    layer.MAP_LAYER = L.geoJSON(data, {
      style: this.detourStyle,
      //@ts-ignore
      arrowheads: { frequency: 'endonly' }
    });

    layer.MAP_LAYER.addTo(this.map);
  }

  setPedDetourLayer(data, layer) {
    layer.MAP_LAYER = L.geoJSON(data, {
      style: this.detourStyle
    });

    layer.MAP_LAYER.addTo(this.map);
  }

  setTwoWayFlowLayer(data, layer) {
    layer.MAP_LAYER = L.geoJSON(data, {
      style: this.flowStyle,
      //@ts-ignore
      arrowheads: { frequency: 'startend' }
    });

    layer.MAP_LAYER.addTo(this.map);
  }

  setOneWayFlowLayer(data, layer) {
    layer.MAP_LAYER = L.geoJSON(data, {
      style: this.flowStyle,
      //@ts-ignore
      arrowheads: { frequency: 'endonly' }
    });

    layer.MAP_LAYER.addTo(this.map);
  }

  zoomToLayer(layer: L.GeoJSON) {
    layer.setStyle({
      weight: 5,
      color: '#0D47A1',
      dashArray: '',
      fillOpacity: 0.2
    });
    vm.map.flyToBounds(layer.getBounds(), {
      maxZoom: 18
    });
  }

  zoomToLatLon(lat: number, lon: number, bldg: string) {
    const anIcon = L.divIcon({
      html: `
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x" style="color: #000000;"></i>
          <i class="fas fa-stack-1x white-text fa-map-marker-alt"></i>
        </span>`,
      iconSize: [20, 20],
      className: 'mapIcon'
    });
    var latlng: L.LatLngExpression = new L.LatLng(lat, lon);
    var anMarker = L.marker(latlng, { icon: anIcon });
    anMarker.on('click', function openBldg(e) {
      vm.zone.run(() => {
        vm.openBuildingDialogByNumber();
      });
    });
    anMarker.addTo(vm.map);

    vm.map.flyTo(latlng, 18);
  }

  //SEARCH
  search = (text$: Observable<string>) =>
    text$.pipe(
      switchMap(term => {
        //if it's an empty string, don't debounce
        if (term === '') {
          return of(term);
        }
        return of(term).pipe(debounceTime(300)); //else wait for them to stop typing before showing up list
      }),
      distinctUntilChanged(),
      switchMap(term =>
        this.searchMap(term).pipe(
          tap(() => (this.searchFailed = false)),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      )
    );

  searchMap(term: string) {
    return this.http
      .get(SRCH_URL, { params: PARAMS.set('srch', term) });
  }

  onBrowseAll() {
    this.searchText = '';
    const el = this.searchInput?.nativeElement;
    if (el) {
      el.focus();
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  searchInputFormatter = (x: any) => {
    if (x && typeof x === 'object') {
      const name = x.NAME ?? '';
      const abbr = x.ABBREV ?? '';
      return name + (abbr ? ` (${abbr})` : '');
    }
    // when x is '' (or null/undefined), show empty string
    return typeof x === 'string' ? x : '';
  };

  searchItemSelected = this.handleSearchResults;

  //BUILDING DIALOG
  openBuildingDialog(bldg: L.GeoJSON) {
    const dialogRef = this.dialog.open(BuildingDialog);

    var feature = <Feature>bldg.feature;

    // dialogRef.componentInstance.bldgName = feature.properties.PropName;
    dialogRef.componentInstance.bldgNumber = feature.properties.PropCID ? feature.properties.PropCID : feature.properties.PropHID;
    dialogRef.componentInstance.bldgCode = feature.properties.PropSTCode ? feature.properties.PropSTCode : null;
    dialogRef.componentInstance.loadBuilding();

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  openBuildingDialogByNumber() {
    const dialogRef = this.dialog.open(BuildingDialog);

    dialogRef.componentInstance.bldgName = vm.searchedBldgName;
    dialogRef.componentInstance.bldgNumber = vm.searchedBldg;
    dialogRef.componentInstance.loadBuilding();

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showSchedule() {
    var newSched = [];


    var schedPoints;
    schedPoints = {
      "type": "FeatureCollection",
      "crs": { "type": "name", "properties": { "name": "EPSG:4326" } },
      "features": []
    };

    if (this.sched != undefined) {
      this.showClassSched = true;
      var section = "";
      var dow = "";
      var prd = "";
      var bldg = "";
      var room = "";
      var c = 0;
      var i = 0;

      var myClass = this.sched.split("|");
      for (c = 0; c < myClass.length; c++) {
        var myTokens = myClass[c].split(",");//I don't know if this will work...
        for (i = 0; i < myTokens.length; i++) {
          if (i == 0) section = myTokens[i].trim();
          else if (i == 1 || i == 5 || i == 9) {
            dow = myTokens[i].trim();
            if (dow == 'M') dow = "MONDAY";
            else if (dow == 'T') dow = "TUESDAY";
            else if (dow == 'W') dow = "WEDNESDAY";
            else if (dow == 'R') dow = 'THURSDAY';
            else if (dow == 'F') dow = 'FRIDAY';
          } else if (i == 2 || i == 6 || i == 10) {
            prd = myTokens[i].trim();
          } else if (i == 3 || i == 7 || i == 11) {
            bldg = myTokens[i].trim();
          } else if (i == 4 || i == 8 || i == 12) {
            room = myTokens[i].trim();
            var newClass = {
              abbrev: bldg,
              section: section,
              dow: dow,
              prd: prd,
              room: room
            }
            newSched.push(newClass);
          }
        }//end for myTokens.length which is split on ,
      }//end for myClass.length which is split on ;
    }

    newSched.forEach(classMeet => {
      var lowestLayer: L.GeoJSON<Feature>;
      var lowestId = 999999;
      var layers = this.boundariesLayer.eachLayer(
        layer => {
          var anLayer = <L.GeoJSON<Feature>>layer;
          var feature = <Feature>anLayer.feature;
          if (feature.properties.ABRV == classMeet.abbrev) {
            if (!lowestLayer || Number(feature.id) < lowestId) {
              lowestId = <number>feature.id;
              lowestLayer = anLayer;
            }
          }
        }
      );
      if (lowestLayer) {
        var anFeature = <Feature>lowestLayer.feature;
        var found = false;
        schedPoints.features.forEach(schedPoint => {
          if (schedPoint.geometry?.coordinates[0] == anFeature.properties.Longitude &&
            schedPoint.geometry?.coordinates[1] == anFeature.properties.Latitude) {
            found = true;
            schedPoint.properties.class += '<br>' + classMeet.section + ' ' + classMeet.dow + ' ' + classMeet.prd;
          }
        });
        if (!found) {
          var newFeature = {
            'type': 'Feature',
            'geometry': {
              'coordinates': [anFeature.properties.Longitude, anFeature.properties.Latitude],
              'type': 'Point'
            },
            'properties': {
              'title': anFeature.properties.PropName + ' (' + (anFeature.properties.PropCID ? anFeature.properties.PropCID : anFeature.properties.PropHID) + ')',
              'class': classMeet.section + ' ' + classMeet.dow + ' ' + classMeet.prd
            }
          };
          schedPoints.features.push(newFeature);
        }
      }
    });

    const anIcon = L.divIcon({
      html: `
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x" style="color: #FF9800;"></i>
          <i class="fas fa-stack-1x black-text fa-users-class"></i>
        </span>`,
      iconSize: [20, 20],
      className: 'mapIcon'
    });

    var schedLayer = L.geoJSON(schedPoints, {
      pointToLayer: function (feature, latlng) {
        var mark = L.marker(latlng, { icon: feature.properties.CUSTOM_ICON ? new L.Icon({ iconUrl: 'assets/' + feature.properties.CUSTOM_ICON, iconSize: [30, 30] }) : anIcon });
        mark.bindPopup('<b>' + feature.properties.title + '</b><p>' + feature.properties.class + '</p>');
        return mark;
      }
    })

    schedLayer.addTo(this.map);
    this.map.flyToBounds(schedLayer.getBounds(), {
      maxZoom: 18
    });
  }

  public clearAllLayers() {
    this.layerGroups.forEach(element => {
      element.LAYERS.forEach(layer => {
        if (layer.CHECKED && layer.MAP_LAYER) {
          layer.MAP_LAYER.removeFrom(this.map);
          layer.CHECKED = false;
        }

      });
    });
  }

  focusZoomIn(e: MouseEvent) {
    e.preventDefault(); // don't just scroll
    (document.getElementById('map-zoom-in') as HTMLElement)?.focus();
  }

}
